import axiosInstance from './axiosInstance';

// Function to send WhatsApp-based authentication
export const sendWhatsAppAuth = async (phone) => {
    console.log('Sending to login API:', `${process.env.REACT_APP_SERVER_URL}/api/auth/wa/`);
    const response = await axiosInstance.post('/api/auth/wa/', { phone });
    return response.data;
};

// Function to send WhatsApp-based OTP verification
export const verifyWhatsAppAuth = async (phone, otp) => {
    console.log('Sending to OTP API:', `${process.env.REACT_APP_SERVER_URL}/api/auth/wa/verif`);
    const response = await axiosInstance.post('/api/auth/wa/verif', { phone, otp });
    return response.data;
};

// Function to send email authentication data
export const sendEmailAuth = async (email, password) => {
    console.log('Sending to login email API:', `${process.env.REACT_APP_SERVER_URL}/api/auth/email`);
    const response = await axiosInstance.post('/api/auth/email', { email, password });
    return response.data;
};

// Function to verify email authentication with OTP
export const verifyEmailAuth = async (email, password, otp) => {
    console.log('Sending to API:', `${process.env.REACT_APP_SERVER_URL}/api/auth/email/verif`);
    const response = await axiosInstance.post('/api/auth/email/verif', { email, password, otp });
    return response.data;
};

// Function to handle forgot password request
export const forgotPassword = async (username, type) => {
    console.log('Sending to API:', `${process.env.REACT_APP_SERVER_URL}/api/auth/forgot`);
    const response = await axiosInstance.post('/api/auth/forgot', { username, type });
    return response.data;
};

// Function to register using WhatsApp
export const registerWithWhatsApp = async (phone) => {
    console.log('Sending to API:', `${process.env.REACT_APP_SERVER_URL}/api/register/wa`);
    const response = await axiosInstance.post('/api/register/wa', { phone });
    return response.data;
};

// Function to register using email
export const registerWithEmail = async (email, name, password, confirmPassword) => {
    console.log('Sending to API:', `${process.env.REACT_APP_SERVER_URL}/api/register/email`);
    const response = await axiosInstance.post('/api/register/email', { email, name, password, confirm_password: confirmPassword });
    return response.data;
};

// Function to verify WhatsApp registration with OTP
export const verifyWhatsAppRegistration = async (phone, otp) => {
    console.log('Sending to API:', `${process.env.REACT_APP_SERVER_URL}/api/register/wa/verif`);
    const response = await axiosInstance.post('/api/register/wa/verif', { phone, otp });
    return response.data;
};

// Function to verify email registration with OTP
export const verifyEmailRegistration = async (name, email, password, otp) => {
    console.log('Sending to API:', `${process.env.REACT_APP_SERVER_URL}/api/register/email/verif`);
    const response = await axiosInstance.post('/api/register/email/verif', { name, email, password, otp });
    return response.data;
};
